import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Subscription } from 'rxjs/Subscription';

import { Restaurant } from './restaurant';

import { RestaurantService } from './restaurant.service';

import { MessageService }     from './message.service';
import { MenuComponent } from './menu.component';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'menu',
	template:'<div> <navigation></navigation><restaurant-menu></restaurant-menu><contact-us></contact-us><timetable-location></timetable-location><footer></footer></div>',
       
})
export class MenuListComponent implements OnInit  {

 deviceInfo = null;
        device = "unknown";
	constructor(
		
   
  	) {}
ngOnInit(): void {
		
	}

}




// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/menu-list.component.ts